import DelayedLinkWithFadeout from "../components/utils/DelayedLinkWithFadeout";

export default function SolicitOption ({nome, link, rota=null, textos, infos}) {
    return (
        <div className="flex">
            <DelayedLinkWithFadeout
                to={ rota != null && infos ? `/atendimento/${rota}/info` : `/atendimento/${rota}`}
                className="flex"
                replace
                state={{
                    opcao: nome,
                    link: link,
                    textos: textos,
                }}
            >
                <div>
                    <button
                        className="py-4 text-4xl shadow-xl px-8  bg-primary-400 text-white text-start tracking-wider rounded-full font-semibold font-tommy disabled:opacity-50"
                    >
                        {nome}
                    </button>
                </div>
            </DelayedLinkWithFadeout> 
            
        </div>
    )
}